import { SiteForm } from "@/components/app/sites/SiteForm";
import { usePageTitle } from "../hooks/usePageTitle";

export function NewSitePage() {
  usePageTitle("Add site | TidyRota");

  return <SiteForm />;
}
